import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import {
    postTypes,
    mediaTypes,
    ActionPost,
    MediaImagePost,
    MediaGalleryPost,
    SocialPost,
    LiveStatsPost,
    MediaVideoPlayerPost
} from 'components/posts';
import { LeaderboardCard } from 'components/leaderboard-card';
import { Banner } from 'components/banner';
import { connect } from 'react-redux';
import ScoringLoader, { endpointNames } from '../../../general/js/loaders/scoring-loader';

class LiveTextWidgetListing extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {};
    }

    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.SHOT_TRACKER);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.SHOT_TRACKER);
    }

    getComponentByContentType(post) {
        const url = get(this.props, `targetsConfig[${post.type}].url`);
        switch (post.card.type) {
            case mediaTypes.IMAGE:
                return <MediaImagePost model={post.card} />;
            case mediaTypes.GALLERY:
                return <MediaGalleryPost model={post.card} />;
            case mediaTypes.VIDEO_PLAYER:
                return <MediaVideoPlayerPost model={post.card} targetUrl={url} />;
            default:
                console.log(`Unknown content type: ${post.card.type}`, post);
                return null;
        }
    }

    getComponentByType(post) {
        const targetsConfig = get(this.props, `targetsConfig[${post.type}]`);

        switch (post.type) {
            case postTypes.ACTION:
                return <ActionPost
                    model={post.card}
                    datePublished={post.datePublished}
                    targetUrl={targetsConfig && targetsConfig.url}
                />;
            case postTypes.MEDIA:
                return this.getComponentByContentType(post);
            case postTypes.SOCIAL:
                return <SocialPost
                    model={post.card}
                    socialType={post.card.type}
                    datePublished={post.datePublished}
                />;
            case postTypes.STATS:
                return <LiveStatsPost
                    post={post}
                    datePublished={post.datePublished}
                    targetsConfig={targetsConfig}
                />;
            case postTypes.LEADERBOARD:
                return <LeaderboardCard
                    model={post.card}
                    datePublished={post.datePublished}
                    targetsConfig={targetsConfig}
                    patronLogo = {this.props.patronLogo}
                />;
            case postTypes.BANNER_SPOT:
                return <Banner model={post.card} />;
            default:
                console.log(`Unknown type: ${post.type}`, post);
                return null;
        }
    }

    renderPosts() {
        if (Array.isArray(!this.props.posts)) return null;

        return this.props.posts.map((post) => (
            <li className="live-text-widget-listing__li" key={post.id}>
                {this.getComponentByType(post)}
            </li>
        ));
    }

    render() {
        if (!Array.isArray(this.props.posts)) return null;

        return (
            <ul className="live-text-widget-listing">
                {this.renderPosts()}
            </ul>
        );
    }
}

LiveTextWidgetListing.propTypes = {
    posts: PropTypes.array,
    targetsConfig: PropTypes.object
};

const mapStateToProps = (state) => ({
    shotTrackerConfig: state.scoring[endpointNames.SHOT_TRACKER],
});

const LiveTextListingContainer = connect(
    mapStateToProps,
    null
)(LiveTextWidgetListing);

export default LiveTextListingContainer;
